import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, commentId }) => {
  switch (type) {
    case drama.FETCH_DRAMA_REPLIES:
      return state.filter(id => id !== commentId);

    case drama.FETCH_DRAMA_REPLIES_FAILED:
      return [...state, commentId];

    default:
      return state;
  }
};
